import styled, {css} from 'styled-components';

import {mixins} from '../../styles';

const H1 = styled.h1`
  ${mixins.f8}
  font-weight: 600;
  margin: 0;
`;

const H2 = styled.h2`
  ${mixins.f6}
  font-weight: 500;
  margin: 0;
`;

const H3 = styled.h3`
  ${mixins.f4}
  font-weight: 500;
  margin: 0;
`;

const H4 = styled.h4`
  ${mixins.f2}
  font-weight: 500;
  margin: 0;
`;

const H5 = styled.h5`
  ${mixins.f1}
  font-weight: 500;
  margin: 0;
`;

const HighlightText = styled.span`
  color: ${({theme}) => theme.branding.content.secondary};
`;

const ErrorText = styled.div`
  ${mixins.f2}
  ${({theme}) => css`
    color: ${theme.palette.red400};
    line-height: ${theme.spacing.s4};
  `};
`;

export {H1, H2, H3, H4, H5, HighlightText, ErrorText};
